import { useEffect, useRef, useState } from "react";

const useInput = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const minDate = "1900-01-01";
  const today = new Date();
  today.setFullYear(today.getFullYear() - 16);
  const maxDate = today.toISOString().split("T")[0];

  const handleFocus = () => {
    setIsFocused(true);
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState: boolean) => !prevState);
  };

  const handleBlur = () =>{
    setIsFocused(false);
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsFocused(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return {
    minDate,
    maxDate,
    wrapperRef,
    isFocused,
    handleFocus,
    handleBlur,
    isPasswordVisible,
    togglePasswordVisibility
  };
};

export default useInput;
